import React, { FC } from 'react';
import cls from './DonePosition.module.css';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export const DonePosition = ({ isDone }) => {
    const { t } = useTranslation();
    if (!isDone) return null;
    return (
        <div className={classNames(cls.DonePosition)}>
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7 8.40039V8.16016C7 7.82422 7.10547 7.54688 7.31641 7.32812C7.53125 7.10938 7.82227 7 8.18945 7C8.56055 7 8.85352 7.10938 9.06836 7.32812C9.2832 7.54688 9.39062 7.82422 9.39062 8.16016V8.40039C9.39062 8.73242 9.2832 9.00781 9.06836 9.22656C8.85742 9.44141 8.56641 9.54883 8.19531 9.54883C7.82812 9.54883 7.53711 9.44141 7.32227 9.22656C7.10742 9.00781 7 8.73242 7 8.40039Z"
                    fill="#616161"
                />
            </svg>
            {t('Gant.DonePosition.return.DonePosition')}
        </div>
    );
};
